import React, { useMemo } from 'react';

/**
 * FloatingParticles — uses rcq- prefixed CSS classes for isolation.
 * Defined in App.css under .rcq-particle keyframe.
 */
export default function FloatingParticles() {
  const particles = useMemo(() =>
    Array.from({ length: 28 }, (_, i) => ({
      id: i,
      size: (0.6 + (i * 0.17) % 2.4).toFixed(1),
      left: ((i * 3.57) % 100).toFixed(1),
      delay: (-(i * 1.43) % 40).toFixed(1),
      duration: (22 + (i * 1.1) % 22).toFixed(1),
      opacity: (0.07 + (i * 0.012) % 0.28).toFixed(2),
      drift: ((i * 4.7) % 60 - 30).toFixed(0),
    }))
  , []);

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Radial glow layers */}
      <div
        className="absolute inset-0 rcq-glow-pulse"
        style={{
          background:
            'radial-gradient(650px circle at 15% 10%, rgba(61,213,109,0.10) 0%, transparent 55%),' +
            'radial-gradient(450px circle at 85% 80%, rgba(61,213,109,0.06) 0%, transparent 55%)',
        }}
      />
      {/* Floating dots */}
      {particles.map(p => (
        <div
          key={p.id}
          className="absolute rounded-full bg-[#3DD56D] rcq-particle"
          style={{
            width: `${p.size}px`,
            height: `${p.size}px`,
            left: `${p.left}%`,
            bottom: '-4px',
            opacity: p.opacity,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--rcq-p-drift': `${p.drift}px`,
          }}
        />
      ))}
    </div>
  );
}
